module.exports = __webpack_public_path__ + "static/media/My ownership.1f2703c0.svg";